import { DateTime } from 'luxon';
import { useCallback, useMemo, useState } from 'react';

export const useLoadingTime = () => {
  const [start, setStart] = useState<number | undefined>(undefined);
  const [stop, setStop] = useState<number | undefined>(undefined);

  const loadingTime = useMemo(() => {
    if (!start || !stop) return;

    return DateTime.fromMillis(stop).diff(DateTime.fromMillis(start), 'milliseconds').milliseconds;
  }, [start, stop]);

  const handleStartLoadingTime = useCallback(() => {
    setStart(Date.now());
  }, []);

  const handleStopLoadingTime = useCallback(() => {
    setStop(Date.now());
  }, []);

  return {
    loadingTime,
    handleStartLoadingTime,
    handleStopLoadingTime,
  };
};
